var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "lightbox__button",
      attrs: { id: _vm.target + "Btn", for: _vm.target },
      on: {
        click: function($event) {
          _vm.setDatastoreValue(),
            _vm.$root.lightboxButtonClick(
              $event,
              _vm.target,
              _vm.prefix,
              _vm.optimizelyPrefix,
              _vm.optimizelyPostfix
            ),
            _vm.youtubeLoad(_vm.target, _vm.youtubeId),
            _vm.setResourceCookie(),
            _vm.setPricingPlanCookie(_vm.pricingPlan)
        }
      }
    },
    [_c("div", [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }